/**
 * Login service request model.
 *
 * @param {Object} state Data model object
 * @param {string} state.username
 * @param {string} state.password
 */

const request = state => ({
  Username: state.username,
  Password: state.password,
});

/**
 * Login service response model.
 *
 * @param {Object} state Data model object
 * @param {string} state.Name
 * @param {string} state.Surname
 * @param {number} state.Token
 * @param {number} state.Type
 * @param {string} state.Username
 */

const response = state => ({
  Company: state.Username.split('@')[1],
  Email: state.Username,
  Name: state.Name,
  Surname: state.Surname,
  Token: state.Token,
  Type: state.Type,
  Username: state.Username,

  company: state.Username.split('@')[1],
  email: state.Username,
  name: state.Name,
  surname: state.Surname,
  token: state.Token,
  type: state.Type,
  username: state.Username,
  aiApiKey: state.aiApiKey,
});

export default {
  request,
  response,
};
